import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import { supabase } from "../supabaseClient/supabaseClient";
import axios from "axios";

const HesapOnaylandi = () => {
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [demoStatus, setDemoStatus] = useState("idle"); // idle, success, failed
  const [errorMsg, setErrorMsg] = useState("");
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectPath = searchParams.get("redirect");

  useEffect(() => {
    let active = true;
    let authListener = null;

    const checkSessionAndAssign = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          if (active) {
            await assignDemo(session.user.id);
          }
        } else {
          // If no session is active yet, listen to auth state changes.
          // Sometimes Supabase takes a moment to process the hash from the email link.
          const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, newSession) => {
            if (event === "SIGNED_IN" && newSession?.user) {
              if (active) {
                subscription.unsubscribe();
                await assignDemo(newSession.user.id);
              }
            }
          });
          authListener = subscription;

          // Set a timeout to fail if no user is found within 6 seconds
          setTimeout(async () => {
            if (!active) return;
            const { data: { session: finalCheck } } = await supabase.auth.getSession();
            if (finalCheck?.user) {
              await assignDemo(finalCheck.user.id);
            } else {
              setStatus("error");
              setErrorMsg("Kullanıcı oturumu doğrulanamadı. Lütfen giriş yapmayı deneyin veya doğrulama bağlantısını tekrar kontrol edin.");
            }
          }, 6000);
        }
      } catch (err) {
        console.error("Session check error:", err);
        if (active) {
          setStatus("error");
          setErrorMsg("Doğrulama işlemi sırasında hata oluştu: " + err.message);
        }
      }
    };

    const assignDemo = async (userId) => {
      try {
        const demoResponse = await axios.post(`${API_URL}/api/auth/assign-demo`, {
          userId: userId
        });
        console.log("✅ Demo tanımlama başarılı:", demoResponse.data);
        if (active) {
          setDemoStatus("success");
          setStatus("success");
        }
      } catch (demoErr) {
        console.error("❌ Demo tanımlama hatası:", demoErr);
        if (!active) return;
        // If already assigned, treat as success
        if (demoErr.response?.status === 400 && demoErr.response?.data?.error?.includes("already has")) {
          setDemoStatus("success");
          setStatus("success");
        } else {
          // Even if demo assignment failed for other reasons, the account was confirmed.
          // We treat it as success since they verified their email, but flag the demo status.
          setDemoStatus("failed");
          setStatus("success");
        }
      }
    };

    checkSessionAndAssign();

    return () => {
      active = false;
      if (authListener) {
        authListener.unsubscribe();
      }
    };
  }, [API_URL]);

  if (status === "loading") {
    return (
      <div className="auth-page-wrapper" style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "linear-gradient(135deg, #f8faff 0%, #e0e7ff 100%)",
        padding: "80px 0"
      }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8} lg={6} xl={5}>
              <div className="auth-card shadow-2xl p-5" style={{
                background: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(20px)",
                borderRadius: "30px",
                border: "1px solid rgba(255, 255, 255, 0.3)"
              }}>
                <div className="mb-4">
                  <Spinner animation="border" variant="primary" style={{ width: "3rem", height: "3rem" }} />
                </div>
                <h4 className="fw-bold mb-3" style={{ color: "#1e293b" }}>Hesabınız Doğrulanıyor...</h4>
                <p className="text-muted">
                  E-posta adresiniz doğrulanıyor ve 1 günlük ücretsiz demo aboneliğiniz tanımlanıyor. Lütfen bekleyin.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="auth-page-wrapper" style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "linear-gradient(135deg, #f8faff 0%, #e0e7ff 100%)",
        padding: "80px 0"
      }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8} lg={6} xl={5}>
              <div className="auth-card shadow-2xl p-5" style={{
                background: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(20px)",
                borderRadius: "30px",
                border: "1px solid rgba(255, 255, 255, 0.3)"
              }}>
                <div className="success-icon-wrapper mb-4" style={{
                  width: "80px",
                  height: "80px",
                  background: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                  boxShadow: "0 10px 20px rgba(239, 68, 68, 0.1)"
                }}>
                  <FaExclamationTriangle size={40} color="#ef4444" />
                </div>
                <h4 className="fw-bold mb-3" style={{ color: "#1e293b" }}>Bir Hata Oluştu</h4>
                <p className="text-muted mb-4">{errorMsg}</p>
                <div className="d-grid">
                  <Button
                    as={Link}
                    to="/Uyegirisi"
                    variant="primary"
                    className="py-3 rounded-pill fw-bold shadow-lg border-0"
                    style={{ background: "linear-gradient(90deg, #4f46e5 0%, #6366f1 100%)" }}
                  >
                    Giriş Sayfasına Git
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="auth-page-wrapper" style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      background: "linear-gradient(135deg, #f8faff 0%, #e0e7ff 100%)",
      padding: "80px 0"
    }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8} lg={6} xl={5}>
            <div className="auth-card shadow-2xl p-5" style={{
              background: "rgba(255, 255, 255, 0.8)",
              backdropFilter: "blur(20px)",
              borderRadius: "30px",
              border: "1px solid rgba(255, 255, 255, 0.3)"
            }}>
              <div className="success-icon-wrapper mb-4" style={{
                width: "80px",
                height: "80px",
                background: "#dcfce7",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
                boxShadow: "0 10px 20px rgba(34, 197, 94, 0.1)"
              }}>
                <FaCheckCircle size={40} color="#22c55e" />
              </div>

              <h2 className="fw-black mb-2" style={{ color: "#1e293b", fontWeight: 900 }}>Harika!</h2>
              <h4 className="fw-bold mb-4" style={{ color: "#334155" }}>Hesabınız Başarıyla Onaylandı</h4>

              {/* Demo Hediye Kutusu */}
              {demoStatus === "failed" ? (
                <div className="demo-gift-box mb-4" style={{
                  background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
                  borderRadius: "20px",
                  padding: "20px",
                  border: "1px solid rgba(239, 68, 68, 0.1)"
                }}>
                  <h5 className="fw-bold mb-2" style={{ color: "#991b1b" }}>Demo Tanımlanamadı</h5>
                  <p className="mb-0 small" style={{ color: "#7f1d1d" }}>
                    Hesabınız onaylandı ancak ücretsiz demo süreniz tanımlanırken geçici bir hata oluştu. 
                    Lütfen destek ekibimizle iletişime geçin veya sisteme giriş yaptıktan sonra profilinizden kontrol edin.
                  </p>
                </div>
              ) : (
                <div className="demo-gift-box mb-4" style={{
                  background: "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)",
                  borderRadius: "20px",
                  padding: "20px",
                  border: "1px solid rgba(79, 70, 229, 0.1)"
                }}>
                  <h5 className="fw-bold mb-2" style={{ color: "#312e81" }}>1 Günlük Demonuz Tanımlandı!</h5>
                  <p className="mb-3 small text-indigo-900" style={{ color: "#3730a3" }}>
                    Stai Mirasım hesabınıza 24 saatlik deneme süresi tanımlanmıştır.
                    <strong> Uygulamayı indirip hemen giriş yapabilirsiniz.</strong>
                  </p>

                  {/* Hızlı İndirme Butonları */}
                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <a href="https://apps.apple.com/us/app/miras%C4%B1m/id6759550556" target="_blank" rel="noopener noreferrer" className="btn btn-dark btn-sm rounded-pill px-3">
                      App Store
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.stai.mirasim" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm rounded-pill px-3">
                      Google Play
                    </a>
                  </div>
                </div>
              )}

              <div className="d-grid gap-3">
                <Button
                  as={Link}
                  to={`/Uyegirisi${redirectPath ? `?redirect=${redirectPath}` : ""}`}
                  variant="primary"
                  className="py-3 rounded-pill fw-bold shadow-lg border-0"
                  style={{ background: "linear-gradient(90deg, #4f46e5 0%, #6366f1 100%)" }}
                >
                  Şimdi Giriş Yapın
                </Button>

                <Link to="/" className="text-decoration-none text-muted small mt-2">
                  Ana Sayfaya Dön
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HesapOnaylandi;
